import { useNavigate } from "react-router-dom";
import { musicGenres } from "../data/musicGenres";

const HomePageMusicGenres = () => {

  const navigate = useNavigate();

  return (
    <div className="select-none cursor-pointer">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4">
        {musicGenres.slice(0, 4).map((genre) => (
          <div
            key={genre.id}
            className="relative genre-card text-center rounded-lg"
            onClick={() => navigate(`/genre/${genre.name.toLowerCase()}`)}
          >
            <img
              src={genre.image}
              alt={genre.name}
              className="genre-image w-full h-[200px] sm:h-[250px] md:h-[300px] object-cover rounded-lg"
            />
            <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black bg-opacity-50 hover:bg-opacity-60">
              <h3 className="text-2xl font-semibold">{genre.name}</h3>
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2 sm:gap-4 mt-4">
        {musicGenres.slice(4, 7).map((genre) => (
          <div
            key={genre.id}
            className="relative genre-card text-center rounded-lg"
            onClick={() => navigate(`/genre/${genre.name.toLowerCase()}`)}
          >
            <img
              src={genre.image}
              alt={genre.name}
              className="genre-image w-full h-[200px] sm:h-[250px] md:h-[300px] object-cover rounded-lg"
            />
            <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black bg-opacity-50 hover:bg-opacity-60">
              <h3 className="text-xl sm:text-3xl font-semibold">{genre.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePageMusicGenres;